<template>
  <v-dialog v-model="dialog" persistent max-width="900">
    <template v-slot:activator="{ on }">
      <v-tooltip bottom>
        <template v-slot:activator="tooltip">
          <div
            v-bind="tooltip.attrs"
            v-on="possuiPropostaEmProcessamento && tooltip.on"
          >
            <v-btn
              v-on="on"
              color="primary"
              class="mr-3"
              :disabled="possuiPropostaEmProcessamento"
            >
              <slot name="title"></slot>
            </v-btn>
          </div>
        </template>
        Não é possível gerar nova proposta, devido à existência de uma
        em processamento.
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="fechar" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h3>
              Para gerar uma nova proposta, adicione os eixos e soluções abaixo.
            </h3>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Eixos do Combo Essencial serão adicionados automaticamente.
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ><ComboboxGroupSolution
              :filter="{
                grupoSolucaoId: atualGrupoSolucao,
              }"
              @changeGroupSolution="changeGroupSolution"
            ></ComboboxGroupSolution>
          </v-col>
          <v-col v-if="atualGrupoSolucao">
            <ComboboxSolution
              :filter="{
                solutions: atualSolutions,
                solucaoId: selectedSolutions,
              }"
              multiple
              @changeSolution="changeSolution"
              returnObject
              :solutionIds="[]"
            ></ComboboxSolution>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="selectedSolutions"
              class="elevation-1 w-100 proposta"
              hide-default-footer
              disable-pagination
            >
              <template v-slot:item.acoes="{ item }">
                <v-btn
                  outlined
                  color="error"
                  class="mr-3"
                  @click="deleteProposta(item)"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>

              <template slot="no-data">
                <span> Nenhum eixo adicionado </span>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div style="text-align: center">
              Investimento total
              <div>
                <strong style="margin-left: 10px"
                  >{{
                    getValorTotal &&
                    getValorTotal.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </strong>
              </div>
            </div>
          </v-col>
          <v-col>
            <div style="text-align: center">
              Contrapartida Sebrae
              <div>
                <strong style="margin-left: 10px">
                  {{
                    getValorContrapartidaSebrae &&
                    getValorContrapartidaSebrae.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </strong>
              </div>
            </div>
          </v-col>
          <v-col>
            <div style="text-align: center">
              Investimento Municipal
              <div>
                <strong style="margin-left: 10px"
                  >{{
                    getValorInvestimentoMunicipal &&
                    getValorInvestimentoMunicipal.toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    })
                  }}
                </strong>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="ultrapassouValorTeto">
          <v-col>
            <div style="width: fit-content; margin-left: auto">
              <strong>
                Você ultrapassou o valor máximo para o município, por favor
                reveja a proposta.
              </strong>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="fechar">Fechar</v-btn>
        <v-btn
          color="info"
          outlined
          text
          @click="onConfirm"
          :disabled="ultrapassouValorTeto"
        >
          <slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { atoresApi } from "@/apis";
import { mapActions, mapGetters } from "vuex";
import ComboboxGroupSolution from "@/modules/group-solution/components/Combobox.vue";
import ComboboxSolution from "@/modules/solution/components/Combobox.vue";
import { solutionAPI } from "@/modules/solution/components/SolutionAPI";
import { propostaApi } from "@/apis/proposta";
import { statusPropostasEnum } from "./statusPropostasEnum";
import moment from "moment";
import { CombosEnum } from "./CombosEnum";
export default {
  name: "ModalNovaProposta",
  components: {
    ComboboxGroupSolution,
    ComboboxSolution,
  },
  props: {
    payload: { type: Object, required: true },
    possuiPropostaEmProcessamento: { type: Boolean, default: false },
    combos: { type: Array, default: [] },
    faixa: { type: Object, default: null },
  },
  computed: {
    ...mapGetters(["isFullAdmin", "city", "user"]),
    combosEssecialSolutionsId() {
      const comboEssencial =
        this.combos &&
        this.combos.length &&
        this.combos.find(
          (item) => (item.municipioPropostaCombosId = CombosEnum.essencial)
        );

      return (
        (comboEssencial &&
          comboEssencial.solucaoIds &&
          comboEssencial.solucaoIds.split(",")) ||
        []
      );
    },
    ultrapassouValorTeto() {
      return (
        this.faixa && this.faixa.faixaTeto < this.getValorInvestimentoMunicipal
      );
    },
    getValorTotal() {
      const sum = this.selectedSolutions.reduce((partialSum, a) => {
        return partialSum + a.precoFaixa;
      }, 0);

      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;
      return sum + valorEssencial;
    },
    getSomaSolucoes() {
      return this.selectedSolutions.reduce((partialSum, a) => {
        return partialSum + a.precoFaixa;
      }, 0);
    },
    faixaSubsidioPreium() {
      return (this.faixa && this.faixa.subsidioPremium) || 0;
    },
    faixaSubsidio() {
      return (this.faixa && this.faixa.faixaSubsidio) || 0;
    },
    getValorTotal() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      return this.getSomaSolucoes + valorEssencial;
    },
    getValorContrapartidaSebrae() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio = valorEssencial * (this.faixaSubsidio / 100);

      const valorComSubsidioPremium =
        this.getSomaSolucoes * (this.faixaSubsidioPreium / 100);

      return valorComSubsidio + valorComSubsidioPremium;
    },
    getValorInvestimentoMunicipal() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio = valorEssencial * (1 - this.faixaSubsidio / 100);

      const valorComSubsidioPremium =
        this.getSomaSolucoes * (1 - this.faixaSubsidioPreium / 100);

      return valorComSubsidio + valorComSubsidioPremium;
    },
  },
  data() {
    return {
      dialog: false,
      atualGrupoSolucao: null,
      atualSolutions: [],
      selectedSolutions: [],
      novaProposta: { groupSolution: [] },

      headers: [
        { text: "Grupo", value: "grupoSolucao.nome", align: "center" },
        { text: "Solução", value: "nome", align: "center" },
        { text: "Ações", value: "acoes", align: "center" },
      ],
    };
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      this.setLoading(true);
      var proposta = {
        municipioId: this.$route.params.id,
        usuarioCriacao: this.user.usuarioId,
        valorTotal: this.getValorTotal,
        status: statusPropostasEnum.emProcessamento,
        municipioPropostaGrupoSolucaoDTO: this.selectedSolutions.map(
          (item) => ({
            idSolucao: item.solucaoId,
            idGrupoSolucao: item.grupoSolucao.grupoSolucaoId,
          })
        ),
        contrapartidaSebrae: this.getValorContrapartidaSebrae,
        investimentoMunicipio: this.getValorInvestimentoMunicipal,
      };

      propostaApi
        .gerarProposta(proposta)
        .then((data) => {
          this.$notification.success("Proposta gerada com sucesso!");
          this.fazerDownloadRelatorio(data.data, `Proposta - ${this.city}`);

          this.$emit("onLoad");
        })
        .catch((err) => {
          this.$notification.error("Erro ao gerar Proposta");
          console.log("Erro no delete ", err);
          this.setLoading(false);
        });
    },
    deleteProposta(item) {
      this.selectedSolutions = this.selectedSolutions.filter(
        (val) => item !== val
      );
    },
    changeSolution(solutions) {
      this.selectedSolutions = solutions;
    },
    async loadSolutionsByGroup(val) {
      try {
        this.atualSolutions = [];
        const data = await solutionAPI.getSolutions([val]);
        const solucoesPrecos =
          (this.faixa &&
            this.faixa.solucoesFaixasDTO &&
            this.faixa.solucoesFaixasDTO.length &&
            this.faixa.solucoesFaixasDTO) ||
          [];

        this.atualSolutions = data.data.filter(
          (val) =>
            !this.combosEssecialSolutionsId.some((ob) => val.solucaoId == ob)
        );

        this.atualSolutions = data.data.filter((val) =>
          solucoesPrecos.some((item) => item.solucaoId == val.solucaoId)
        );

        if (this.atualSolutions && this.atualSolutions.length) {
          this.atualSolutions = this.atualSolutions.map((val) => {
            const solucaoAtual = solucoesPrecos.find(
              (a) => a.solucaoId == val.solucaoId
            );

            return {
              ...val,
              precoFaixa: (solucaoAtual && solucaoAtual.preco) || undefined,
              custoFaixa: (solucaoAtual && solucaoAtual.custo) || undefined,
              solucaoFaixaid:
                (solucaoAtual && solucaoAtual.solucaoFaixaid) || undefined,
            };
          });
        }
      } catch (error) {
        console.log("🚀 ~ loadSolutionsByGroup ~ error:", error);
      }
    },
    fazerDownloadRelatorio(file, nomeArquivo) {
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        `${nomeArquivo} - ${moment().format("DD.MM.YYYY.HH.mm")}.pdf`
      );

      document.body.appendChild(fileLink);
      fileLink.click();
      this.dialog = false;
      this.setLoading(false);
    },
    changeGroupSolution(grupoSolucaoId) {
      this.atualGrupoSolucao = grupoSolucaoId;
      this.loadSolutionsByGroup(this.atualGrupoSolucao);
    },
    fechar() {
      this.selectedSolutions = [];
      this.atualGrupoSolucao = null;
      this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.comboEssencial {
  color: var(--corPrimaria);
  cursor: pointer;
}
.combo {
  .header {
    background: black;
    margin-left: -28px;
    width: 135%;
    text-align: center;
    margin-top: -16px;
    margin-bottom: 5px;
  }
}
</style>
